import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ChargingCleaner = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path d="M2.598 4.604c-.74 0-1.339.599-1.339 1.339v2.052c0 .804.652 1.456 1.456 1.456h11.991l.369-1.058-1.231-.934a14.042 14.042 0 0 0-8.486-2.855h-2.76zM.592 5.943c0-1.108.898-2.006 2.006-2.006h2.76c3.21 0 6.332 1.05 8.889 2.991l1.617 1.227-.684 1.963H2.715A2.123 2.123 0 0 1 .592 7.995V5.943z" />
      <path d="M5.41 3.937c.184 0 .333.149.333.333v.598a2.006 2.006 0 0 1-2.006 2.006H.925a.333.333 0 1 1 0-.666h2.812c.74 0 1.339-.599 1.339-1.339v-.598c0-.184.149-.333.333-.333zm3.715.632c.184 0 .333.149.333.333v4.709a.333.333 0 1 1-.666 0V4.902c0-.184.149-.333.333-.333zm-1.855.757c.184 0 .333.149.333.333v2.736a.333.333 0 1 1-.666 0V5.659c0-.184.149-.333.333-.333zM2.715 9.45c.184 0 .333.149.333.333v.462a1.818 1.818 0 0 1-1.817 1.817H.469a.333.333 0 1 1 0-.666h.762a1.15 1.15 0 0 0 1.15-1.15v-.462c0-.184.149-.333.333-.333z" />
    </svg>
  );
};

ChargingCleaner.category = 'product-category';

ChargingCleaner.displayName = 'ChargingCleaner';
